import type { CSSProperties } from 'react';
import { cn } from '@worldcoo/ui/lib/utils';

const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

/**
 * A 0-9 column ten cells tall behind a one-digit window, so `-digit * 10%` lands on the numeral: every
 * cell MUST share the height in `cell`. All CSS; nothing re-renders to animate.
 */
export function DigitRoll(props: { digit: number; cell: string; className?: string }) {
	return (
		<span className={cn('relative inline-block overflow-hidden', props.className)}>
			{/* Sizes the window. The shown digit, not a fixed `0`: the swap fallback's digits are not tabular. */}
			<span aria-hidden className={cn('invisible', props.cell)}>
				{props.digit}
			</span>
			{/* Centred so a `1` gets a narrow slot; a `-translate-x-1/2` class would fight the inline `translate`. */}
			<span
				aria-hidden
				style={{ translate: `-50% ${-props.digit * 10}%` } as CSSProperties}
				className="absolute top-0 left-1/2 flex flex-col items-center transition-[translate] duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none"
			>
				{DIGITS.map((d) => (
					<span key={d} className={cn('whitespace-nowrap', props.cell)}>
						{d}
					</span>
				))}
			</span>
		</span>
	);
}
